import { useMutation, useQuery } from "@tanstack/react-query";
import { fetch3, fetch4, fetch5 } from "../commonApis/commonApis";
import { ApiResponse } from "./loginApis";
const url = process.env.REACT_APP_BASE_URL;

interface CreateRequestPayload {
  companyId: string
}
interface CreateCancelPayload {
  requestId: string
}

export const useIntegrationData = (page: number, searchFor: string, channelType: string, value: string | undefined) => {
  return useQuery({
    queryKey: ["integrationData"],
    queryFn: async () => {
      const res = await fetch3(`${url}/api/channels/channels-list?page=${page}&searchFor=${searchFor}&channelType=${channelType}&value=${value}`, "get");

      if (!res || !res.data) {
        return res.message
      }

      return res.data; // 👈 This returns your full user object
    },
    staleTime: 1000 * 60 * 5,
  });
};

export const useRequestChannelMutation = () => {
  return useMutation({
    mutationFn: async (payload: CreateRequestPayload) => {
      const res: ApiResponse = await fetch4(`${url}/api/channels-status`, payload);

      // Manually throw error if success is false
      if (!res.success) {
        throw res.message || 'Something went wrong';
      }

      return res.data;
    },
    onSuccess: (data) => {
      console.log('✅ OTP requested successfully:', data);
    },
    onError: (error: any) => {
      console.error('❌ OTP request failed:', error.message);
    }
  });
};


export const useCancelChannelMutation = () => {
  return useMutation({
    mutationFn: async (payload: CreateCancelPayload) => {
      const res: ApiResponse = await fetch4(`${url}/api/channels-status/cancel-channel`, payload);

      // Manually throw error if success is false
      if (!res.success) {
        throw res.message || 'Something went wrong';
      }

      return res.data;
    },
    onSuccess: (data) => {
      console.log('✅ OTP requested successfully:', data);
    },
    onError: (error: any) => {
      console.error('❌ OTP request failed:', error.message);
    }
  });
};

export const useMerchantAllowedShippingChannels = (clientId?: string) => {
  return useQuery({
    queryKey: ["merchantAllowedShippingChannels", clientId],
    queryFn: async () => {
      if (!clientId) return [];
      const res = await fetch3(`${url}/api/integrations/merchant-channels/${clientId}?channelType=shipping`, "get");
      if (!res || !res.success) return [];
      return res.data || [];
    },
    enabled: !!clientId,
  });
};

export const useConnectMerchant3PLCredentialsMutation = () => {
  return useMutation({
    mutationFn: async (payload: { connectionId: string; credentials: Record<string, any>; environment?: "test" | "prod" }) => {
      const res: ApiResponse = await fetch4(`${url}/api/integrations/connections/${payload.connectionId}/connect`, {
        credentials: payload.credentials,
        environment: payload.environment || "prod",
      });
      if (!res.success) throw res.message || "Failed to save 3PL credentials";
      return res.data;
    },
  });
};

export const useUpdateConnectionEnvironmentMutation = () => {
  return useMutation({
    mutationFn: async (payload: { connectionId: string; environment: "test" | "prod" }) => {
      const res: ApiResponse = await fetch5(
        `${url}/api/integrations/connections/${payload.connectionId}/environment`,
        "PATCH",
        { environment: payload.environment }
      );
      if (!res.success) throw res.message || "Failed to update environment";
      return res.data;
    },
  });
};